export default class LumcNews {
    constructor() {
        this.previousCategory = '';
        this.previousMonthYear = '';
        this.previousMonth = '';
        this.previousTheme = '';
        this.previousKeyword = '';

        this.list = document.getElementById('newslist');

        const searchParams = new URLSearchParams(window.location.search);

        let pageNumber = 1;
        const pageSearchParam = searchParams.get('page');

        if (pageSearchParam) {
            pageNumber = Number(pageSearchParam);
        }

        this.page = pageNumber;

        this.category = searchParams.get('category') || '';
        this.year = searchParams.get('year') || 0;
        this.month = searchParams.get('month') || 0;
        this.theme = searchParams.get('theme') || '';
        this.keyword = searchParams.get('keyword') || '';

        this.language = document.documentElement.lang;

        this.firstArticleDiv = document.getElementById('first-article');
        this.firstArticle = document.getElementById('first-article');

        this.showFirstArticle = false;

        if (!this.list) {
            return;
        }

        this.loadButton = document.querySelector('[data-loadmore-button]');

        this.categorySelect = document.querySelector(
            '[data-categories-select]'
        );
        this.yearSelect = document.querySelector('[data-year-select]');
        this.monthSelect = document.querySelector('[data-month-select]');
        this.themeSelect = document.querySelector('[data-themes-select]');
        this.keywordSelect = document.querySelector('[data-keywords-select]');

        this.noArticlesMessage = document.getElementById('no-articles-message');

        if (this.month === 0 && this.monthSelect) {
            this.monthSelect.parentElement.classList.add('hidden');
        }

        this.init();
    }

    init() {
        const self = this;

        self.API = self.loadButton.dataset.api || '/static/json/newsdata.json';

        this.loadInitialPage();

        if (this.loadButton) {
            this.loadButton.addEventListener('click', (event) =>
                self.loadMore(event)
            );
        }

        if (this.categorySelect) {
            this.categorySelect.addEventListener('change', (e, i) =>
                self.filterByCategory(e, i)
            );
        }

        if (this.yearSelect) {
            this.yearSelect.addEventListener('change', (e, i) =>
                self.filterByMonthYear(e, i)
            );
        }

        if (this.monthSelect) {
            this.monthSelect.addEventListener('change', (e, i) =>
                self.filterByMonthYear(e, i)
            );
        }

        if (this.themeSelect) {
            this.themeSelect.addEventListener('change', (e, i) =>
                self.filterByTheme(e, i)
            );
        }

        if (this.keywordSelect) {
            this.keywordSelect.addEventListener('change', (e, i) =>
                self.filterByKeyword(e, i)
            );
        }
    }

    loadInitialPage() {
        // console.log("In _loadInitialPage ");

        const self = this;

        Promise.resolve(
            self.getData(
                0,
                self.page,
                self.category,
                self.year,
                self.month,
                self.theme,
                self.keyword,
                self.language
            )
        ).then((data) => {
            if (!data || !data.newsitems || data.newsitems.length === 0) {
                self.noArticlesMessage.classList.remove('hidden');
            } else {
                self.noArticlesMessage.classList.add('hidden');
            }

            self.renderNewsItems(self.list, data, true);
            this.loadButton.classList.remove('hidden');
        });
    }

    filterByCategory(_e, _i) {
        // console.log(e);
        // console.log(i);
        // console.log( "In _filterByCategory: " + this.categorySelect.value)
        // console.log("Previous category: " + this.previousCategory);
        // console.log("Current category: " + this.categorySelect.value);

        if (this.categorySelect.value === this.previousCategory) {
            // console.log("Returning because of same category");
            return;
        }

        this.previousCategory = this.categorySelect.value;

        if (this.categorySelect.value === 'default') {
            this.category = '';
        } else {
            this.category = this.categorySelect.value;
        }

        // console.log("filtering by category : " + this.category);

        this.reset();
        this.loadInitialPage();
    }

    filterByMonthYear(e, i) {
        if (
            this.yearSelect.value === this.previousYear &&
            this.monthSelect.value === this.previousMonth
        ) {
            return;
        }

        if (this.yearSelect.value === 'default') {
            this.year = '';
            this.month = '';

            this.monthSelect.value = 'default';

            if (this.previousMonth !== '' && this.previousMonth !== 'default') {
                this.monthSelect.getElementsByTagName('option')[
                    this.previousMonth - 1
                ].selected = '';
                this.monthSelect.getElementsByTagName('option')[0].selected =
                    'selected';
            }

            this.monthSelect.parentElement.classList.add('hidden');
        } else if (
            this.yearSelect.value !== 'default' &&
            this.monthSelect.value === 'default'
        ) {
            this.year = this.yearSelect.value;
            this.month = '';
            this.monthSelect.parentElement.classList.remove('hidden');
        } else {
            this.monthSelect.parentElement.classList.remove('hidden');
            this.month = this.monthSelect.value;
            this.year = this.yearSelect.value;
        }

        this.previousYear = this.yearSelect.value;
        this.previousMonth = this.monthSelect.value;

        // console.log("filtering by month / year - month : " + this.month + " - year: " + this.year);

        this.reset();

        this.loadInitialPage();
    }

    filterByTheme(e, i) {
        if (this.themeSelect.value === this.previousTheme) {
            // console.log("Returning because of same theme");
            return;
        }

        this.previousTheme = this.themeSelect.value;

        if (this.themeSelect.value === 'default') {
            this.theme = '';
        } else {
            this.theme = this.themeSelect.value;
        }

        // console.log("filtering by theme : " + this.theme);

        this.reset();
        this.loadInitialPage();
    }

    filterByKeyword(e, i) {
        if (this.keywordSelect.value === this.previousKeyword) {
            return;
        }

        this.previousKeyword = this.keywordSelect.value;

        if (this.keywordSelect.value === 'default') {
            this.keyword = '';
        } else {
            this.keyword = this.keywordSelect.value;
        }

        this.reset();
        this.loadInitialPage();
    }

    reset() {
        // console.log("In reset");

        this.page = 1;
        this.firstArticle.innerHTML = '';
        this.list.innerHTML = '';
        this.loadButton.parentElement.parentElement.style.display = 'block';
        window.history.pushState(
            null,
            null,
            `${window.location.pathname}?page=1&category=${this.category}&year=${this.year}&month=${this.month}&theme=${this.theme}&keyword=${this.keyword}`
        );
    }

    loadMore(e) {
        this.page += 1;

        e.preventDefault();
        e.stopPropagation();

        const self = this;

        // The value of skip is the length of the list at the bottom of the page
        // plus one for the item with the picture at the top of the page.
        // If there is no picture in the first item don't add one!

        let skip = 0;

        const numberOfLoadedNewsItems = this.list.querySelectorAll(
            '.news-article-preview'
        ).length;

        if (this.showFirstArticle) {
            skip = numberOfLoadedNewsItems + 1;
        } else {
            skip = numberOfLoadedNewsItems;
        }

        Promise.resolve(
            self.getData(
                skip,
                1,
                self.category,
                self.year,
                self.month,
                self.theme,
                self.keyword,
                self.language
            )
        ).then((data) => {
            self.renderNewsItems(self.list, data, false);
            // console.log(data);

            let id = '';

            if (data && data.length > 0) {
                id = data[0].id;
            } else {
                const { hash } = window.location;
                id = hash.replace('#', '');
            }

            window.history.pushState(
                null,
                null,
                `${window.location.pathname}?page=${self.page}&category=${self.category}&year=${self.year}&month=${self.month}&theme=${self.theme}&keyword=${self.keyword}#${id}`
            );
        });
    }

    /**
     * Fetch news articles
     * @param skip
     * @param page
     * @param category
     * @param year
     * @param month
     * @param theme
     * @param keyword
     * @param language
     */
    getData(skip, page, category, year, month, theme, keyword, language) {
        // make an ajax call to the server
        const doSkip = skip || 0;
        const url = this.API;

        return fetch(
            `${url}?skip=${doSkip}&page=${page}&category=${category}&year=${year}&month=${month}&theme=${theme}&keyword=${keyword}&language=${language}`
        )
            .then((response) => response.json())
            .catch((ex) => {
                // eslint-disable-next-line no-console
                console.log('parsing failed', ex);
            });
    }

    renderNewsItems(element, data, isFirstLoad) {
        if (!element || !data || !data.newsitems) {
            this.loadButton.parentElement.parentElement.style.display = 'none';
            return;
        }

        const articles = data.newsitems;

        if (articles.length === 0 || data.islast) {
            // Hide the load button if there are no more articles.
            this.loadButton.parentElement.parentElement.style.display = 'none';
        }

        let firstArticleHasImage = false;

        if (articles[0] && articles[0].imageUrl) {
            firstArticleHasImage = true;
            this.showFirstArticle = true;
        }

        if (isFirstLoad && firstArticleHasImage) {
            LumcNews.renderFirstNewsItem(this.firstArticle, articles[0]);
            articles.shift();
            this.firstArticleDiv.style.display = 'block';
        } else if (isFirstLoad && !firstArticleHasImage) {
            this.firstArticleDiv.style.display = 'none';
        }

        let innerHTMLList = '';

        // eslint-disable-next-line no-restricted-syntax
        for (const article of articles) {
            innerHTMLList += `
                <div class="cell small-12 medium-4"></div>
                <div class="cell small-12 medium-8 news-article-preview" id='${
                    article.id
                }'>
                    <a href="${article.articleUrl}">
                        ${(() => {
                            if (
                                article.smallImageUrl &&
                                article.smallImageUrl !== undefined &&
                                article.smallImageUrl !== ''
                            ) {
                                return `<img class='small-news-image news-image-mobile' src='${article.smallImageUrl}'>`;
                                // eslint-disable-next-line no-else-return
                            } else {
                                return '';
                            }
                        })()}

                        <h3>${article.title}</h3>
                        <div class="time-and-subject">
                            <div>${article.date}</div>
                            <div>${article.newsCategory}</div>
                        </div>
                        
                        <p>
                        ${(() => {
                            if (
                                article.smallImageUrl &&
                                article.smallImageUrl !== undefined &&
                                article.smallImageUrl !== ''
                            ) {
                                return `<img class='small-news-image' src='${article.smallImageUrl}'>`;
                                // eslint-disable-next-line no-else-return
                            } else {
                                return '';
                            }
                        })()}

                            ${article.lead}
                        </p>
                    </a>
                </div>`;
        }

        // eslint-disable-next-line no-param-reassign
        element.innerHTML += innerHTMLList;

        if (window.location.hash) {
            let elementId = window.location.hash;
            elementId = elementId.replace('#', '');

            const elmnt = document.getElementById(elementId);

            if (elmnt) {
                elmnt.scrollIntoView();
            }
        }

        if (isFirstLoad && this.firstArticle) {
            this.firstArticle.scrollIntoView();
        }
    }

    static renderFirstNewsItem(element, article) {
        if (!element || !article) {
            return;
        }

        const innerHTMLList = `
                <div class="grid-x grid-margin-x" id="${
                    article.id
                }">                    
                        <div class="cell small-12 medium-6 large-8">
                            <div class="square-image">
                                <a href="${article.articleUrl}">
                                    <img src="${article.imageUrl || ''}">
                                </a>
                            </div>
                        </div>
                        <div class="cell small-12 medium-6 large-4">
                            <div class="article-highlight-text">
                                <div class="article-text-bottom-align">
                                    <a href="${article.articleUrl}">
                                        <h3>${article.title}</h3>
                                        <div class="time-and-subject">
                                            <div>${article.date}</div>
                                            <div>${article.newsCategory}</div>
                                        </div>
                                        <p>${article.lead}
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>
                </div>`;

        // eslint-disable-next-line no-param-reassign
        element.innerHTML += innerHTMLList;
    }
}
